import React from 'react'
import { IconProps } from '../types'

export default function FileIcon({
    className = 'h-[13px] w-[10px]',
    fill = 'rgba(0, 0, 0, 0.4)',
    ...props
}: IconProps) {
    return (
        <svg
            width="10"
            height="13"
            viewBox="0 0 10 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M1.8165 12.5625H8.039C9.252 12.5625 9.8555 11.9473 9.8555 10.7285V5.40825C9.8555 4.65225 9.7735 4.32425 9.30475 3.84375L6.07025 0.55675C5.62525 0.0995001 5.26175 0 4.59975 0H1.8165C0.6095 0 0 0.621 0 1.84V10.7285C0 11.953 0.6095 12.5625 1.8165 12.5625ZM1.86325 11.6193C1.25975 11.6193 0.94325 11.2968 0.94325 10.711V1.8575C0.94325 1.2775 1.25975 0.94325 1.86925 0.94325H4.47075V4.34775C4.47075 5.086 4.84575 5.44925 5.57225 5.44925H8.91225V10.711C8.91225 11.2968 8.6015 11.6193 7.99225 11.6193H1.86325ZM5.67775 4.56425C5.44925 4.56425 5.35525 4.47075 5.35525 4.23625V1.125L8.73025 4.5645L5.67775 4.56425ZM7.084 7.0605H2.6365C2.42575 7.0605 2.2735 7.21875 2.2735 7.418C2.2735 7.623 2.426 7.78125 2.63675 7.78125H7.084C7.289 7.78125 7.44725 7.623 7.44725 7.418C7.44725 7.21875 7.289 7.0605 7.084 7.0605ZM7.084 9.1055H2.6365C2.42575 9.1055 2.2735 9.2695 2.2735 9.4745C2.2735 9.67375 2.426 9.82625 2.63675 9.82625H7.084C7.289 9.82625 7.44725 9.67375 7.44725 9.4745C7.44725 9.2695 7.289 9.1055 7.084 9.1055Z"
                fill={fill}
            />
        </svg>
    )
}
